import { render, staticRenderFns } from "./OnofficeConfirmation.vue?vue&type=template&id=2a2e0032&"
import script from "./OnofficeConfirmation.vue?vue&type=script&lang=js&"
export * from "./OnofficeConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports